<template>

</template>

<script>

    import { getDurationPerImage } from '../../utils/duration';
    import { formatDateTime } from '../../utils/formatDate';

    export default {


        methods: {
            getFixedBlockType(type) {
                switch (type) {
                    case 1:
                        return 'Vast foto blok';
                    case 2:
                        return 'Vast video blok';
                }

                return 'Vast blok';
            },

            isFixedBlock(block) {
                return (block?.settings || []).some(setting => {
                    return setting.name === 'fixed_block' && Number(setting.value) === 1;
                });
            },
            isCondolenceBlock(block) {
                return (block.type === 6);
            },

            isInloopUitloopBlock(block) {
                return (block.type === 5);
            },

            isMediaBlock(block) {
                return (block.type === 4);
            },

            isSpeakerBlock(block) {
                return (block.type === 3);
            },

            isPhotoBlock(block) {
                return (block.type === 1);
            },

            isVideoBlock(block) {
                return (block.type === 2);
            },

            isCallBlock(block) {
                return (block.type === 7);
            },

            getSettingByName(setting_name, settings) {
                return (settings || []).find((setting => {
                    return (setting_name === setting.name);
                }));
            },

            getImageInfo(main_block, block) {
                if (block.files.length <= 0 || block.has_manual_action) {
                    return [];
                }

                return [
                    `${block.files.length} foto${block.files.length > 1 ? '\'s' : ''}`,
                    `${this.formatNumber(this.getDurationPerImageInBlock(main_block, block), 1)} seconden per foto`,
                ];
            },

            canRepeatMedia(block) {
                return block.files.length <= 0 && (
                    this.isInloopUitloopBlock(block) ||
                    this.isCondolenceBlock(block) ||
                    this.isSpeakerBlock(block) ||
                    (this.isMediaBlock(block) && block.subblocks.length && this.isPhotoBlock(block.subblocks[0]))
                );
            },

            getVideoInfo(block) {
                if (block.files.length <= 0) {
                    return [];
                }

                return [
                    `${block.files.length} video${block.files.length > 1 ? '\'s' : ''}`,
                ];
            },

            isParentBlock() {
                return this.block.parent_id === null;
            },

            getDurationPerImageInBlock(main_block, block) {
                const parentBlock = main_block.find(parentBlockToFind => parentBlockToFind.id === block.parent_id);

                return getDurationPerImage(block, parentBlock ? parentBlock.files : []);
            },

            formatDateTime(date, format = 'DD-MM-YYYY HH:mm') {
                return formatDateTime(date, format);
            },
        },
    };
</script>

<style scoped>

</style>
